import React, {useContext, useEffect, useState} from "react";
import {Button, Checkbox, Col, Form, Input, Row} from "antd";
import {Link, Outlet, useLocation, useNavigate} from "react-router-dom";
import useAuth from "../auth/useAuth";
import {ToastContext} from "./components/ToastProvider";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {TranslateContext} from "../utils/TranslateProvider";




export default function SignIn({user,from, error}) {

    let navigate = useNavigate();
    let location = useLocation();
    let auth = useAuth();
    let toast = useContext(ToastContext);
    const {t, getLanguageMenu } = useContext(TranslateContext);

    useEffect(() => {
        if (auth.user) {
            navigate('/dashboard');
        }
    }, [auth.user]);




    const [loading, setLoading] = React.useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const onFinish = async (values: any) => {
        setLoading(true)

        const response = await auth.signIn(
            values.username,
            values.password,
            () => {
                navigate(from || "/dashboard");
            },
            setLoading,
            values.remember,
            setErrorMessage);

    };


    let validateStatus = "";
    let helpMessage = "";
    if (errorMessage) {
        validateStatus = "error";
        helpMessage = errorMessage;
    }




    return (
                <>
                        {/*<Form*/}
                        {/*    name="normal_login"*/}
                        {/*    className="login-form"*/}
                        {/*    onFinish={onFinish}*/}
                        {/*    rootClassName={"login-form "}*/}
                        {/*>*/}
                        {/*    <Form.Item*/}
                        {/*        name="username"*/}
                        {/*        rules={[{ required: true, message: t('loginRules') }]}*/}
                        {/*        validateStatus={validateStatus}*/}
                        {/*        help={helpMessage}*/}
                        {/*        status={errorMessage ? t('error') : ""}*/}
                        {/*    >*/}
                        {/*        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder={t('account')} />*/}
                        {/*    </Form.Item>*/}
                        {/*    <Form.Item*/}
                        {/*        name="password"*/}
                        {/*        rules={[{ required: true, message:t('passwordRules') }]}*/}
                        {/*        validateStatus={validateStatus}*/}
                        {/*        status={errorMessage ? t('error') : ""}*/}

                        {/*    >*/}
                        {/*        <Input.Password*/}
                        {/*            prefix={<LockOutlined className="site-form-item-icon" />}*/}
                        {/*            type="password"*/}
                        {/*            placeholder={t('password')}*/}

                        {/*        />*/}
                        {/*    </Form.Item>*/}
                        {/*    <Form.Item>*/}
                        {/*        <Form.Item name="remember" valuePropName="checked" noStyle>*/}
                        {/*            <Checkbox>{t("rememberMe")}</Checkbox>*/}
                        {/*        </Form.Item>*/}

                        {/*        /!*<Link className="login-form-forgot" to={"/request-new-password"}>*!/*/}
                        {/*        /!*    {t("forgotPassword")}*!/*/}
                        {/*        /!*</Link>*!/*/}
                        {/*    </Form.Item>*/}

                        {/*    <Form.Item>*/}
                        {/*        <Button loading={loading} type="primary" htmlType="submit" className="login-form-button">*/}
                        {/*            {t("login")}*/}
                        {/*        </Button>*/}
                        {/*    </Form.Item>*/}

                        {/*</Form>*/}
                    {/*{getLanguageMenu('white')}*/}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontFamily: "Arial, sans-serif",
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "12px",
                                padding: "24px",
                                maxWidth: "700px",
                                width: "100%",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            }}
                        >
                            <h1 style={{ fontSize: "22px", marginBottom: "12px" }}>
                                Information importante : la plateforme a été déplacée
                            </h1>

                            <div
                                style={{
                                    backgroundColor: "#fff3cd",
                                    border: "1px solid #ffeeba",
                                    padding: "12px",
                                    borderRadius: "8px",
                                    marginBottom: "12px",
                                }}
                            >
                                <p>
                                    La plateforme est désormais accessible sur :{" "}
                                    <strong>
                                        <a
                                            href="https://portail.sna-gz.com"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            https://portail.sna-gz.com
                                        </a>
                                    </strong>
                                </p>
                            </div>

                            <p>
                                Un e-mail d’information contenant les nouvelles modalités de connexion a été envoyé.
                            </p>

                            <p>
                                En cas de difficulté ou pour toute question, merci de contacter le service client.
                            </p>

                            <a
                                href="http://portail.sna-gz.com"
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                    display: "inline-block",
                                    marginTop: "12px",
                                    padding: "12px 18px",
                                    backgroundColor: "#0b5fff",
                                    color: "#ffffff",
                                    textDecoration: "none",
                                    borderRadius: "8px",
                                    fontWeight: "600",
                                }}
                            >
                                Accéder au portail
                            </a>

                            <p style={{ fontSize: "13px", color: "#555", marginTop: "14px" }}>
                                Pensez à vérifier votre dossier spam si vous ne retrouvez pas l’e-mail.
                            </p>
                        </div>
                    </div>
                </>

    );
}


function InfoPlateforme() {
    return (
        <div
            style={{
                backgroundColor: "#f6f7f9",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
                fontFamily: "Arial, sans-serif",
            }}
        >
            <div
                style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "24px",
                    maxWidth: "700px",
                    width: "100%",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                }}
            >
                <h1 style={{ fontSize: "22px", marginBottom: "12px" }}>
                    Information importante : la plateforme a été déplacée
                </h1>

                <div
                    style={{
                        backgroundColor: "#fff3cd",
                        border: "1px solid #ffeeba",
                        padding: "12px",
                        borderRadius: "8px",
                        marginBottom: "12px",
                    }}
                >
                    <p>
                        La plateforme est désormais accessible sur :{" "}
                        <strong>
                            <a
                                href="http://portail.sna-gz.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                http://portail.sna-gz.com
                            </a>
                        </strong>
                    </p>
                </div>

                <p>
                    Un e-mail d’information contenant les nouvelles modalités de connexion a été envoyé.
                </p>

                <p>
                    En cas de difficulté ou pour toute question, merci de contacter le service client.
                </p>

                <a
                    href="http://portail.sna-gz.com"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                        display: "inline-block",
                        marginTop: "12px",
                        padding: "12px 18px",
                        backgroundColor: "#0b5fff",
                        color: "#ffffff",
                        textDecoration: "none",
                        borderRadius: "8px",
                        fontWeight: "600",
                    }}
                >
                    Accéder au portail
                </a>

                <p style={{ fontSize: "13px", color: "#555", marginTop: "14px" }}>
                    Pensez à vérifier votre dossier spam si vous ne retrouvez pas l’e-mail.
                </p>
            </div>
        </div>
    );
}
